import styled from 'styled-components';

import { Radio as AntdRadio } from 'antd';
import RadioGroup from './RadioGroup';
import RadioButton from './RadioButton';

const prefix = '.ant-radio';
const radioClass = prefix;
const checkedClass = `${prefix}-checked`;
const innerClass = `${prefix}-inner`;
const focusedClass = `${prefix}-focused`;

const Radio = styled(AntdRadio)`
    &&,
    ${/* sc-selector */ prefix} {
        font-family: ${({ theme }) => theme.font.regular};
    }

    &&:hover
        ${/* sc-selector */ radioClass}
        ${/* sc-selector */ innerClass},
        ${/* sc-selector */ radioClass}:hover
        ${/* sc-selector */ innerClass},
        ${/* sc-selector */ focusedClass}
        ${/* sc-selector */ innerClass} {
        border-color: ${({ theme }) => theme.colour.primary};
    }

    ${/* sc-selector */ checkedClass} {
        :after,
        ${/* sc-selector */ innerClass} {
            border-color: ${({ theme }) => theme.colour.primary};
        }
    }

    ${/* sc-selector */ innerClass}:after {
        background-color: ${({ theme }) => theme.colour.primary};
    }
`;

Radio.Group = RadioGroup;
Radio.Button = RadioButton;

export default Radio;
